import i18next from 'i18next'
const t = (key) => i18next.t(key)

const articleMaintenanceNavigationSteps = [
    {
        // Este selector busca cualquier enlace <a> que apunte a "/wialon_connection"
        target: '[data-tour-group="Catálogos"]',
        content: t('Haz click en el menu "Catalogos" para desplegar las opciones.'),
        placement: 'right',
        spotlightClicks: true, // IMPORTANTE: Esto permite al usuario hacer clic en el enlace durante el tour
        disableBeacon: true,
        disableScrolling: true, // Evita que el tour intente hacer scroll automaticamente
    },
    {
        // Paso 2: Apuntar al enlace final (ahora visible)
        target: '[data-tour="subroute-Proveedores"]',
        content: t('Ahora, selecciona el sub-menu "Proveedores".'),
        placement: 'right',
        spotlightClicks: true, // Permite al usuario navegar
        disableBeacon: true,
        disableScrolling: true, // Evita que el tour intente hacer scroll automaticamente

    },
    {
        // Paso 2: Apuntar al enlace final (ahora visible)
        target: '[data-tour="subroute-suppliers/maintenance"]',
        content: t('Ahora, selecciona la opcion "Catalogos de Proveedores".'),
        placement: 'right',
        spotlightClicks: true, // Permite al usuario navegar
        disableBeacon: true,
        disableScrolling: true, // Evita que el tour intente hacer scroll automaticamente

    },
]

export const getArticleMaintenanceNewTourSteps = ({ hasUnitMeasures = true } = {}) => {
    const commonSteps = [
        {
            target: 'body',
            content: t('Bienvenido al modulo de Articulos. Aqui puedes gestionar tus articulos y sus documentos.'),
            placement: 'center',
        },
        {
            target: '[data-tour="descripcion-articulo"]',
            content: t('Escribe la descripcion del articulo aqui.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
    ]

    const withUnitMeasureSteps = [
        {
            target: '[data-tour="unidad-medida-articulo"]',
            content: t('Selecciona la unidad de medida del articulo aqui.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
    ]

    const withoutUnitMeasureSteps = [
        {
            target: '[data-tour="unidad-medida-articulo"]',
            content: t('No hay unidades de medida disponibles. Primero debes crear una con el boton +.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
        {
            target: '[data-tour="agregar-unidad-medida-articulo"]',
            content: t('Haz clic en + para abrir el modal y crear una unidad de medida.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
        {
            target: '[data-tour="modal-unidad-medida-codigo"]',
            content: t('Captura el codigo de la nueva unidad de medida.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
        {
            target: '[data-tour="modal-unidad-medida-descripcion"]',
            content: t('Captura la descripcion de la nueva unidad de medida.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
        {
            target: '[data-tour="modal-unidad-medida-guardar"]',
            content: t('Guarda la unidad de medida para poder seleccionarla en el articulo.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
        {
            target: '[data-tour="unidad-medida-articulo"]',
            content: t('Ahora ya puedes seleccionar la unidad de medida y continuar con el flujo.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
    ]

    const finalFormSteps = [
        {
            target: '[data-tour="captura-obligatoria-articulo"]',
            content: t('Indica si la captura de este articulo es obligatoria en los documentos.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
        {
            target: '[data-tour="grabar-articulo"]',
            content: t('Una vez que hayas completado los campos, haz clic aqui para guardar el nuevo articulo.'),
            spotlightClicks: true,
            scrollToSteps: true,
        },
    ]

    return [
        ...commonSteps,
        ...(hasUnitMeasures ? withUnitMeasureSteps : withoutUnitMeasureSteps),
        ...finalFormSteps,
        ...articleMaintenanceNavigationSteps,
    ]
}

export const tourSteps = (t) => ({
    '/': [
        {
            target: 'body',
            content: t('¡Bienvenido a Geo Transport! Este es un breve recorrido para configurar los primeros pasos.'),
            placement: 'center',
            disableScrolling: true,
            disableOverlayClose: true,
            disableOverlay: false,
            spotlightClicks: false,

        },
        {
            // Este selector busca cualquier enlace <a> que apunte a "/wialon_connection"
            target: '[data-tour-group="Configuración"]',
            content: t('Primero, haz clic en el menú "Configuración" para desplegar las opciones.'),
            placement: 'right',
            // spotlightClicks: true, // IMPORTANTE: Esto permite al usuario hacer clic en el enlace durante el tour
            disableBeacon: true,
            disableScrolling: true, // Evita que el tour intente hacer scroll automático
            scrollToSteps: true, // Permite que el tour haga scroll para mostrar el elemento si no es visible

        },
        {
            // Paso 3 (último): Apuntar al enlace "Conexión API a Plataformas"
            // navigateTo: al hacer click en "Siguiente" (Finalizar) redirige a esa ruta automáticamente
            target: '[data-tour="route-wialon_connection"]',
            content: t('Ahora, selecciona "Conexión API a Plataformas".'),
            placement: 'right',
            spotlightClicks: true, // Permite al usuario navegar haciendo click directamente en el elemento
            navigateTo: '/wialon_connection', // Al pulsar "Siguiente" en este paso, navega aquí
            triggerTargetOnNext: true,
            disableBeacon: true,
            disableScrolling: true, // Evita que el tour intente hacer scroll automático

        },
    ],
    '/wialon_connection': [
        {
            target: 'body',
            content: t('Este es el módulo de Wialon Connection, en donde puedes gestionar la conexión con el sistema Wialon para el seguimiento de unidades.'),
            placement: 'center',
        },
        {
            target: 'table',
            content: t('En este apartado podras cambiar  la configuración de la conexión con Wialon.'),
            placement: 'top',
            spotlightClicks: true,
        },
        {
            // Este selector busca cualquier enlace <a> que apunte a "/wialon_connection"
            target: '[data-tour-group="Catálogos"]',
            content: t('Haz click en el menú "Catálogos" para desplegar las opciones.'),
            placement: 'right',
            // spotlightClicks: true, // IMPORTANTE: Esto permite al usuario hacer clic en el enlace durante el tour
            disableBeacon: true,
            disableScrolling: true, // Evita que el tour intente hacer scroll automático
        },
        {
            // Paso 2: Apuntar al enlace final (ahora visible)
            target: '[data-tour="subroute-Clientes"]',
            content: t('Ahora, selecciona el sub-menu "Clientes".'),
            placement: 'right',
            // spotlightClicks: true, // Permite al usuario navegar
            disableBeacon: true,
            disableScrolling: true, // Evita que el tour intente hacer scroll automático

        },
        {
            // Último paso: Apuntar al enlace "Clientes"
            // Al hacer click en "Siguiente" navega automáticamente a /clients/catalogs
            target: '[data-tour="subroute-clients/catalogs"]',
            content: t('Ahora, selecciona la opción "Clientes".'),
            placement: 'right',
            spotlightClicks: true, // Permite al usuario navegar haciendo click directamente
            navigateTo: '/clients/catalogs', // Al pulsar "Siguiente" en este paso, navega aquí
            disableBeacon: true,
            disableScrolling: true, // Evita que el tour intente hacer scroll automático

        },
    ],
    '/clients/catalogs': [
        {
            target: 'body',
            content: t('Este es el módulo de Gestión de Clientes. Aquí puedes administrar los perfiles.'),
            placement: 'center',
        },
        {
            target: '[data-tour="add-button"]',
            content: t('Haz clic aquí para agregar un nuevo cliente en una nueva fila.'),
            placement: 'bottom',
            spotlightClicks: true,
            navigateTo: '/clients/catalogs/new',

        },

    ],
    '/clients/catalogs/new': [
        {
            target: 'body',
            content: t('Agrega un nuevo cliente completando los siguientes campos.'),
            placement: 'center',
            scrollToSteps: true, // Permite que el tour haga scroll para mostrar el elemento si no es visible
        },
        {
            target: '[data-tour="codigo-clientes"]',
            content: t('Ingresa el código único del cliente aquí. Este código se usará para identificar al cliente en el sistema.'),
            placement: 'bottom',
            spotlightClicks: true,
            scrollToSteps: true, // Permite que el tour haga scroll para mostrar el elemento si no es visible
        },
        {
            target: '[data-tour="nombre-clientes"]',
            content: t('Ingresa el nombre del cliente aquí.'),
            placement: 'bottom',
            spotlightClicks: true,
            disableScrolling: true,
            scrollToSteps: true, // Permite que el tour haga scroll para mostrar el elemento si no es visible
        },
        {
            target: '[data-tour="direccion-clientes"]',
            content: t('Ingresa la dirección del cliente aquí.'),
            placement: 'bottom',
            spotlightClicks: true,
            scrollToSteps: true, // Permite que el tour haga scroll para mostrar el elemento si no es visible
        },
        // {
        //     target: '[data-tour="prefijo-clientes"]',
        //     content: t('Ingresa el prefijo del cliente aquí.'),
        //     placement: 'bottom',
        //     spotlightClicks: true,
        //     scrollToSteps: true, // Permite que el tour haga scroll para mostrar el elemento si no es visible
        // },
        {
            target: '[data-tour="grabar-cliente"]',
            content: t('Una vez que hayas completado los campos, haz clic aquí para guardar el nuevo cliente.'),
            placement: 'bottom',
            spotlightClicks: true,
            scrollToSteps: true, // Permite que el tour haga scroll para mostrar el elemento si no es visible
        },
        {
            target: 'body',
            content: t('Estos son los campos principales para registrar un nuevo cliente. Completa la información y guarda para agregarlo al sistema.'),
            placement: 'center',
        },
        {
            // Este selector busca cualquier enlace <a> que apunte a "/wialon_connection"
            target: '[data-tour-group="Catálogos"]',
            content: t('Haz click en el menú "Catálogos" para desplegar las opciones.'),
            placement: 'right',
            // spotlightClicks: true, // IMPORTANTE: Esto permite al usuario hacer clic en el enlace durante el tour
            disableBeacon: true,
            disableScrolling: true, // Evita que el tour intente hacer scroll automático
        },
        {
            target: '[data-tour="subroute-Empleados"]',
            content: t('Ahora, selecciona el sub-menu "Empleados".'),
            placement: 'right',
            // spotlightClicks: true,
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            // Último paso: Apuntar al enlace "Empleados"
            // Al hacer click en "Siguiente" navega automáticamente a /employees/employees
            target: '[data-tour="subroute-employees/employees"]',
            content: t('Ahora, selecciona la opción "Empleados".'),
            placement: 'right',
            spotlightClicks: true, // Permite al usuario navegar haciendo click directamente
            navigateTo: '/employees/employees', // Al pulsar "Siguiente" en este paso, navega aquí
            disableBeacon: true,
            disableScrolling: true,
        },

    ],
    '/employees/employees': [
        {
            target: 'body',
            content: t('Este es el módulo de Gestión de Empleados. Aquí puedes administrar los accesos y perfiles.'),
            placement: 'center',
        },
        {
            target: '[data-tour="add-button"]',
            content: t('Haz clic aquí para agregar un nuevo empleado en una nueva fila.'),
            placement: 'bottom',
            spotlightClicks: true,
            navigateTo: '/employees/employees/new',
        },

    ],
    '/employees/employees/new': [
        {
            target: 'body',
            content: t('Estos son los campos principales para registrar un nuevo empleado. Completa la información y guarda para agregarlo al sistema.'),
            placement: 'center',
        },
        {
            target: '[data-tour="employee-code"]',
            content: t('Ingresa el código único del empleado aquí. Este código se usará para identificar al empleado en el sistema.'),
            placement: 'bottom',
            spotlightClicks: true,
        },
        {
            target: '[data-tour="employee-name"]',
            content: t('Ingresa el nombre del empleado aquí.'),
            placement: 'bottom',
            spotlightClicks: true,
        },
        {
            target: '[data-tour="employee-submit-button"]',
            content: t('Una vez que hayas completado los campos, haz clic aquí para guardar el nuevo empleado.'),
            placement: 'bottom',
            spotlightClicks: true,
        },
        {
            target: 'body',
            content: t('Estos son los campos principales para registrar un empleado. Completa la información y guarda para agregarlo al sistema.'),
            placement: 'center',
        },
        {
            target: '[data-tour-group="Catálogos"]',
            content: t('Haz click en el menú "Catálogos" para desplegar las opciones.'),
            placement: 'right',
            // spotlightClicks: true,
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            target: '[data-tour="subroute-Unidades"]',
            content: t('Ahora, selecciona el sub-menu "Unidades".'),
            placement: 'right',
            // spotlightClicks: true,
            disableBeacon: true,
            disableScrolling: true,
        },
        {
            // Último paso: Apuntar al enlace "Unidades"
            // Al hacer click en "Siguiente" navega automáticamente a /units/catalogs
            target: '[data-tour="subroute-units/catalogs"]',
            content: t('Ahora, selecciona la opción "Unidades".'),
            placement: 'right',
            spotlightClicks: true, // Permite al usuario navegar haciendo click directamente
            navigateTo: '/units/catalogs', // Al pulsar "Siguiente" en este paso, navega aquí
            disableBeacon: true,
            disableScrolling: true,
        },
    ],
    '/units/catalogs': [
        {
            target: 'body',
            content: t('Este es el módulo de Unidades. Aquí puedes gestionar vehículos, remolques y otros equipos.'),
            placement: 'center',
        },
        {
            target: '[data-tour="add-button"]',
            content: t('Haz clic aquí para registrar una nueva unidad.'),
            placement: 'bottom',
            spotlightClicks: true,
            navigateTo: '/units/catalogs/new',
        },

    ], '/units/catalogs/new': [
        {
            target: 'body',
            content: t('Este es el módulo de Unidades. Aquí puedes gestionar vehículos, remolques y otros equipos.'),
            placement: 'center',
        },

        {
            target: '[data-tour="economico-units"]',
            content: t('Escribe el número económico de la unidad aquí.'),
            spotlightClicks: true,
        },
        {
            target: '[data-tour="descripcion-units"]',
            content: t('Escribe la descripción de la unidad aquí.'),
            spotlightClicks: true,
        },
        {
            target: '[data-tour="codigo-barras-units"]',
            content: t('Escanea o ingresa el código de barras de la unidad aquí.'),
            spotlightClicks: true,
        },
        {
            target: '[data-tour="icono-units"]',
            content: t('Selecciona el ícono que representa la unidad aquí.'),
            placement: 'left',
            spotlightClicks: true,
        },
        {
            target: '[data-tour="grabar-units"]',
            content: t('Una vez que hayas completado los campos, haz clic aquí para guardar la nueva unidad.'),
            spotlightClicks: true,
            isAbsoluteLast: true,
        },

        // {
        //     // Este selector busca cualquier enlace <a> que apunte a "/wialon_connection"
        //     target: '[data-tour-group="Catálogos"]',
        //     content: t('Haz click en el menú "Catálogos" para desplegar las opciones.'),
        //     placement: 'right',
        //     spotlightClicks: true, // IMPORTANTE: Esto permite al usuario hacer clic en el enlace durante el tour
        //     disableBeacon: true,
        //     disableScrolling: true, // Evita que el tour intente hacer scroll automático
        // },
        // {
        //     // Paso 2: Apuntar al enlace final (ahora visible)
        //     target: '[data-tour="subroute-Remolques"]',
        //     content: t('Ahora, selecciona el sub-menu "Remolques".'),
        //     placement: 'right',
        //     spotlightClicks: true, // Permite al usuario navegar
        //     disableBeacon: true,
        //     disableScrolling: true, // Evita que el tour intente hacer scroll automático
        // },
        // {
        //     // Paso 2: Apuntar al enlace final (ahora visible)
        //     target: '[data-tour="subroute-trailers/catalogs"]',
        //     content: t('Ahora, selecciona la opción "Catálogos de Remolques".'),
        //     placement: 'right',
        //     spotlightClicks: true, // Permite al usuario navegar
        //     disableBeacon: true,
        //     disableScrolling: true, // Evita que el tour intente hacer scroll automático
        // },
    ],
    // '/driver/drivers': [
    //     {
    //         target: 'body',
    //         content: t('Bienvenido al módulo de Conductores. Aquí gestionas la información de tus conductores.'),
    //         placement: 'center',
    //     },
    //     {
    //         target: '[data-tour="add-button"]',
    //         content: t('Usa este botón para abrir el formulario de registro de conductor.'),
    //     },
    //     {
    //         target: '[data-tour="add-row-button"]',
    //         content: t('O usa este botón para agregar rápidamente en la tabla.'),
    //     }
    // ],
    // '/suppliers/maintenance': [
    //     {
    //         target: 'body',
    //         content: t('Este es el módulo de Proveedores. Aquí puedes gestionar tus proveedores y sus documentos.'),
    //         placement: 'center',
    //     },
    //     {
    //         target: '[data-tour="add-button"]',
    //         content: t('Haz clic aquí para registrar un nuevo proveedor.'),
    //         spotlightClicks: true,
    //     },

    // ], '/suppliers/maintenance/new': [
    //     {
    //         target: 'body',
    //         content: t('Este es el módulo de Proveedores. Aquí puedes gestionar tus proveedores y sus documentos.'),
    //         placement: 'center',
    //     },
    //     {
    //         target: '[data-tour="supplier-name"]',
    //         content: t('Escribe el nombre del proveedor aquí.'),
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: '[data-tour="add-button"]',
    //         content: t('Haz clic aquí para registrar un nuevo proveedor.'),
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: '[data-tour="grabar-proveedor"]',
    //         content: t('Una vez que hayas completado los campos, haz clic aquí para guardar el nuevo proveedor.'),
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: 'body',
    //         content: t('Estos son los campos principales para registrar un nuevo proveedor.'),
    //         placement: 'center',
    //     }


    // ],
    // '/trailers/catalogs': [
    //     {
    //         target: 'body',
    //         content: t('Bienvenido al módulo de Remolques. Aquí puedes gestionar tus remolques y otros equipos.'),
    //         placement: 'center',
    //     },
    //     {
    //         target: '[data-tour="add-button"]',
    //         content: t('Haz clic aquí para registrar un nuevo remolque.'),
    //         placement: 'bottom',
    //         spotlightClicks: true,
    //     },


    // ],
    // '/trailers/catalogs/new': [
    //     {
    //         target: 'body',
    //         content: t('Bienvenido al módulo de Remolques. Aquí puedes gestionar tus remolques y otros equipos.'),
    //         placement: 'center',
    //     },
    //     {
    //         target: '[data-tour="add-button"]',
    //         content: t('Haz clic aquí para registrar un nuevo remolque.'),
    //         placement: 'bottom',
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: '[data-tour="codigo-remolque"]',
    //         content: t('Escribe el código del remolque aquí.'),
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: '[data-tour="descripcion-remolque"]',
    //         content: t('Escribe la descripción del remolque aquí.'),
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: '[data-tour="codigo-barras-remolque"]',
    //         content: t('Escanea o ingresa el código de barras del remolque aquí.'),
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: '[data-tour="icono-unidad-remolque"]',
    //         content: t('Selecciona el ícono que representa el remolque aquí.'),
    //         spotlightClicks: true,
    //         placement: 'left',
    //     },
    //     {
    //         target: '[data-tour="tipo-remolque-sat"]',
    //         content: t('Selecciona el tipo de remolque según el catálogo SAT aquí.'),
    //         spotlightClicks: true,
    //         placement: 'left',
    //     },
    //     {
    //         target: '[data-tour="grabar-remolque"]',
    //         content: t('Una vez que hayas completado los campos, haz clic aquí para guardar el nuevo remolque.'),
    //         spotlightClicks: true,
    //     },
    //     {
    //         target: 'body',
    //         content: t('Estos son los campos principales para registrar un nuevo remolque.'),
    //         placement: 'center',
    //     },
    //     {
    //         // Este selector busca cualquier enlace <a> que apunte a "/wialon_connection"
    //         target: '[data-tour-group="Catálogos"]',
    //         content: t('Haz click en el menú "Catálogos" para desplegar las opciones.'),
    //         placement: 'right',
    //         spotlightClicks: true, // IMPORTANTE: Esto permite al usuario hacer clic en el enlace durante el tour
    //         disableBeacon: true,
    //         disableScrolling: true, // Evita que el tour intente hacer scroll automático
    //     },
    //     {
    //         // Paso 2: Apuntar al enlace final (ahora visible)
    //         target: '[data-tour="subroute-Articulos"]',
    //         content: t('Ahora, selecciona el sub-menu "Artículos".'),
    //         placement: 'right',
    //         spotlightClicks: true, // Permite al usuario navegar
    //         disableBeacon: true,
    //         disableScrolling: true, // Evita que el tour intente hacer scroll automático
    //     },
    //     {
    //         // Paso 2: Apuntar al enlace final (ahora visible)
    //         target: '[data-tour="subroute-articles/maintenance"]',
    //         content: t('Ahora, selecciona la opción "Catálogos de Artículos".'),
    //         placement: 'right',
    //         spotlightClicks: true, // Permite al usuario navegar
    //         disableBeacon: true,
    //         disableScrolling: true, // Evita que el tour intente hacer scroll automático
    //     },

    // ],
    // '/articles/maintenance': [
    //     {
    //         target: 'body',
    //         content: t('Bienvenido al módulo de Artículos. Aquí puedes gestionar tus artículos y sus documentos.'),
    //         placement: 'center',
    //     },
    //     {
    //         target: '[data-tour="add-button"]',
    //         content: t('Haz clic aquí para registrar un nuevo artículo.'),
    //         spotlightClicks: true,
    //     },
    // ],
    // '/articles/maintenance/new': getArticleMaintenanceNewTourSteps(),

    // '/sys_company_administrator': [
    //     {
    //         target: 'body',
    //         content: t('Bienvenido al módulo de Administrador de la Compañía. Aquí gestionas la información de tu compañía.'),
    //         placement: 'center',
    //     },

    // ],

});


